import React, { Component } from "react";
import { connect } from "react-redux";
import { checkAuth, login } from "../actions";
class Login extends Component {
  constructor(props) {
    super(props);
    this.state = {
      username: "",
      password: "",
      app_type: "",
      errorMsg: null,
    };
  }

  _onChangeHandler = (e) => {
    this.setState({
      [e.target.name]: e.target.value,
    });
  };

  _onClickHandler = () => {
    this.setState({
      errorMsg: null,
    });
    const { username, password, app_type } = this.state;
    if (username && password) {
      this.props.login(username, password, app_type || null);
    } else {
      this.setState({
        errorMsg: "Please fill all credentials!",
      });
    }
  };

  render() {
    const { username, password, app_type, errorMsg } = this.state;
    const { auth_error } = this.props.auth;
    return (
      <div className="login-home">
        <div className="login-container">
          <h1>Shelfwatch</h1>
          <div>
            <h4>Username</h4>
            <input
              type="text"
              name="username"
              value={username}
              onChange={(e) => this._onChangeHandler(e)}
            />
          </div>
          <div>
            <h4>Password</h4>
            <input
              type="password"
              name="password"
              value={password}
              onChange={(e) => this._onChangeHandler(e)}
            />
          </div>
          <div>
            <h4>App Type</h4>
            <select
              name="app_type"
              value={app_type}
              onChange={(e) => this._onChangeHandler(e)}
            >
              <option value="">Old App</option>
              <option value="plusapp">Plus App</option>
              <option value="proapp">Pro App</option>
            </select>
          </div>
          {errorMsg ? (
            <p className="errorMsg">{errorMsg}</p>
          ) : auth_error ? (
            <p className="errorMsg">{auth_error}</p>
          ) : null}
          <button className="btnSuccess" onClick={() => this._onClickHandler()}>
            Login
          </button>
        </div>
      </div>
    );
  }

  componentDidMount() {
    this.props.checkAuth();
  }
}

const mapStateToProps = (state) => {
  return {
    auth: state.auth,
  };
};

export default connect(mapStateToProps, { checkAuth, login })(Login);
